import { Table as AntTable } from 'antd'
import styled from 'styled-components'
import { ColumnsType } from 'antd/lib/table'

import { CardSection, Loader } from 'components'
import { NumberUtils } from 'utils'

import { OrganizationAnalyticsCompanies } from '../../hooks/useOrganizationAnalyticsSummary/api'
import { LoaderContainer } from '..'

const Table = styled(AntTable)<OrganizationAnalyticsCompanies>`
  table {
    border-collapse: collapse !important;
  }
  .ant-table-cell {
    border-bottom: unset;
  }
  .ant-table-body {
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.colors.baseColor[900]};
      background-clip: padding-box;
    }
  }
  .ant-table-cell-scrollbar {
    background-color: ${({ theme }) => theme.colors.white} !important;
    border: none !important;
  }
  th {
    background: transparent !important;
    border: 0px !important;
    font-family: Inter;
    font-size: 18px;
    text-align: center;
    font-weight: 700;
  }
` as unknown as typeof AntTable

interface Props {
  companies: OrganizationAnalyticsCompanies[]
  isLoading: boolean
}
export const CompaniesCard: React.FC<Props> = ({ companies, isLoading }) => {
  const columns: ColumnsType<OrganizationAnalyticsCompanies> = [
    {
      title: 'Productor',
      width: 120,
      render: ({ company }) => `${company.name}`,
    },
    {
      title: 'Lotes',
      render: ({ totals }) => NumberUtils.localize(totals.lots),
    },
    {
      title: 'Ha',
      render: ({ totals }) => NumberUtils.localize(NumberUtils.roundedNumber(totals.size)),
    },
  ]

  return (
    <CardSection title="Productores">
      {isLoading ? (
        <LoaderContainer $minHeight="352px" align="middle" justify="center">
          <Loader />
        </LoaderContainer>
      ) : (
        <Table
          pagination={false}
          columns={columns}
          dataSource={companies}
          rowKey={({ company }) => company.id}
          scroll={{ y: 291 }}
        />
      )}
    </CardSection>
  )
}
